"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _mdiMaterialUi = require("mdi-material-ui");
var _core = require("@material-ui/core");
var _Alert = _interopRequireDefault(require("./Alert.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Alert = function Alert(_ref) {
  var _classNames;
  var appearance = _ref.appearance,
    _ref$hideIcon = _ref.hideIcon,
    hideIcon = _ref$hideIcon === void 0 ? false : _ref$hideIcon,
    title = _ref.title,
    actions = _ref.actions,
    _ref$noShadow = _ref.noShadow,
    noShadow = _ref$noShadow === void 0 ? false : _ref$noShadow,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  // HOOKS
  var classes = (0, _Alert.default)();
  var isInfo = appearance === 'info';
  var isSuccess = appearance === 'success';
  var isDanger = appearance === 'danger';
  var isWarning = appearance === 'warning';

  // STYLES
  var classAlert = (0, _classnames.default)(classes.alert, (_classNames = {}, _defineProperty(_classNames, classes.alertSmall, size === 'small'), _defineProperty(_classNames, classes.alertInfo, isInfo), _defineProperty(_classNames, classes.alertSuccess, isSuccess), _defineProperty(_classNames, classes.alertDanger, isDanger), _defineProperty(_classNames, classes.alertWarning, isWarning), _defineProperty(_classNames, classes.noShadow, noShadow), _classNames));
  var classAlertIcon = (0, _classnames.default)(_defineProperty({}, classes.alertSmallIcon, size === 'small'));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.alertContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classAlert,
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.titleContainer
  }, !hideIcon && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mr: 2,
    display: "flex",
    className: classAlertIcon
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isInfo && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Information, null), isSuccess && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.CheckboxMarked, null), isWarning && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.AlertBox, null), isDanger && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Alert, null))), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.actions
  }, actions))));
};
var _default = Alert;
exports.default = _default;